module.exports = __webpack_public_path__ + "@/assets/img/examenes2B2020R19.d4302d15.png";